'use client';

import { Box, HStack } from '@terra/ui-styled-system';
import { ArrowDown01Icon, ArrowRight01Icon } from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { Collapsible } from '../../../../components/collapsible';
import { MarkdownPreview } from '../../../markdown-preview';
import type { TraceToolCall } from '../types';

export function SelectEvidenceToolCard({
  toolCall,
}: {
  toolCall: TraceToolCall;
}) {
  const t = useTranslations('designSystem.chat');
  const [open, setOpen] = useState(false);
  const description =
    typeof toolCall.args?.explanation === 'string'
      ? toolCall.args.explanation.trim()
      : '';

  return (
    <Collapsible.Root open={open} onOpenChange={({ open }) => setOpen(open)}>
      <Collapsible.Trigger asChild disabled={!description}>
        <HStack
          as="button"
          gap={1.5}
          py={1}
          fontSize="xs"
          color="fg.muted"
          cursor={description ? 'pointer' : 'default'}
        >
          <Box>{t('selectEvidence')}</Box>
          {description ? (
            open ? (
              <ArrowDown01Icon size={12} />
            ) : (
              <ArrowRight01Icon size={12} />
            )
          ) : null}
        </HStack>
      </Collapsible.Trigger>
      <Collapsible.Content>
        <Box pt={1} pb={2} color="fg.muted">
          <MarkdownPreview source={description} fontSize={12} compact />
        </Box>
      </Collapsible.Content>
    </Collapsible.Root>
  );
}
